import controller from './projects-scope.controller';
import template from './projects-scope.html';

export default { controller, template };



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/projecs-scope/projects-scope.component.js